import { html, LitElement, css, unsafeCSS } from 'lit';

import './card';

import style from './tooltip.scss';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { friendlyURL, isTouchDevice } from '../shared/utils';
import { processDesc } from '../shared/parse';

export class TooltipComponent extends LitElement {

    static get properties() {
        return {
            selected: Number,
            tooltip: Object,
            top: Number,
            left: Number,
            bottom: Number
        }
     }

    constructor() {
        super();
        this.selected = null;
        this.tooltip = null;
        this.top = 0;
        this.bottom = 0;
        this.left = 0;
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    debouncer(func, timeout) {

        var timeoutID, timeout = timeout || 500;
        return function () {
            var scope = this, args = arguments;
            clearTimeout(timeoutID);
            timeoutID = setTimeout(function () {
                func.apply(scope, Array.prototype.slice.call(args));
            }, timeout);
        }
    }

    mouseOver(ev,val){        
        if(ev.clientY + 200 > window.innerHeight){
            this.bottom = 1;
            this.top = 0;
        }else{
            this.top = ev.clientY;
            this.bottom = 0;
        }                    
        this.left = ev.clientX;
        if(isTouchDevice()){
            this.left = (window.innerWidth/2)-125;
            this.top = (window.innerHeight/2)-100;
            this.bottom = 0;
        }
        if(typeof val === 'number'){
            this.selected = val;
        }else{
            this.tooltip = val;
        }
    }

    convertTypeToPath(type,img){
        if(type === 'Status')
            return type.toLowerCase();
        if(type === 'Affix')
            return 'affixes';
        return `${type.toLowerCase()}${img?'s':''}`;
    }

    mouseOut(ev){
        this.selected = null;
        this.tooltip = null;
    }
   
    render() {
        let s = {
            left: this.left
        };
        if(this.top > 0)
            s.top = this.top;
        if(this.bottom > 0)
            s.bottom = this.bottom;
        let tstyle = Object.keys(s).map((k)=>`${k}:${s[k]}px`).join(';');
        return html`
            <div class="overlay" style="${!isTouchDevice()||(!this.selected&&!this.tooltip)?'display:none;':''}"></div>
            ${this.tooltip ? html`
                <div class="tooltip" style="${tstyle}">
                    <h3>${this.tooltip.caption||this.tooltip.name}</h3>
                    <small>
                        ${this.tooltip.type}
                    </small>
                    <div class="artwork ${this.tooltip.type.toLowerCase()}" 
                        style="background-image:url(./images/${this.convertTypeToPath(this.tooltip.type,true)}/${(this.tooltip.artwork||'dt_portrait_bolgar').replace(/ /g,'%20')}.webp);"></div>
                    <span class="tooltip-desc">
                        ${unsafeHTML(processDesc(this.tooltip.desc))}
                    </span>
                    ${isTouchDevice() && this.tooltip.type !== 'Affix' ? html`<br><a href="./${this.convertTypeToPath(this.tooltip.type)}/${friendlyURL(this.tooltip.name)}">Open Link</a>`:''}
                </div>
            `: html`
                <card-component link=${isTouchDevice()?'yes':''} id=${this.selected} style="${tstyle}"></card-component>                                
            `}            
        `;
    }
}

customElements.define('tooltip-component', TooltipComponent);